export default "__VITE_ASSET__15a6950b__"